// This icon file is generated automatically.
var CaretDownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 704l221.7-288H290.3L512 704z" } }] }, "name": "caret-down", "theme": "outlined" };
export default CaretDownOutlined;
